import React from 'react';
import { DsIcon } from '@tokenyico/design-system/dist/reactJS';
import { useTranslation } from 'react-i18next';

export default ({ documents }) => {
  const { t } = useTranslation();

  return (
    <div id="dashboard-documents">
      <h2>{t('shared.documents')}</h2>
      {documents.map((document) => (
        <a href={document.url} target="_blank" rel="noreferrer" key={document.url}>
          <div>
            <div>
              <DsIcon name="file" color="var(--coolGrey-400)" />
              {document.label}
            </div>

            <DsIcon name="download" color="var(--primary)" />
          </div>
        </a>
      ))}
    </div>
  );
};
